import { combineReducers } from 'redux';
import { moduleReducer } from './module';
import uiReducer from './ui';
import studentReducer from './student';
import awardReducer from './award';
import activityReducer from './activity';
import errorLogger from './errorLogger';
import recordingsReducer from './recordings';

export const reducers = combineReducers({
  ui: uiReducer,
  login: moduleReducer,
  student: studentReducer,
  activity: activityReducer,
  award: awardReducer,
  errorLogger,
  recordings: recordingsReducer
});
